import React from 'react'
import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue, useResetRecoilState } from 'recoil'

import {
  Button,
  BUTTON_VARIANT_PRIMARY,
  BUTTON_VARIANT_SECONDARY,
  Modal,
  ModalBody,
  ModalFoot,
  ModalHead,
  SpacingVertical,
  SPACING_32
} from 'mailup-web-components'
import InputTitle from './InputTitle'
import InputLists from './InputLists'

import { modalCopyState, modalCopyValidState } from '../recoil/state/modals'
import { modalCopyConfirmCallback } from '../recoil/callbacks/callbacks'

const ModalCopy = () => {
  const intl = useIntl()

  const { show } = useRecoilValue(modalCopyState)
  const validForm = useRecoilValue(modalCopyValidState)

  const handleClose = useResetRecoilState(modalCopyState)

  const handleConfirm = useRecoilCallback(modalCopyConfirmCallback, [])

  return (
    <Modal
      show={show}
      showClose
      onClose={handleClose}
      data-mu-test='modal-template-copy'
    >
      <ModalHead
        title={intl.formatMessage({
          id: 'Load.Bee.ModalTitleForCopyTemplateToLists'
        })}
      />
      <ModalBody>
        <p>
          {intl.formatMessage({
            id: 'Load.Bee.ModalLabelForCopyTemplateToLists'
          })}
        </p>
        <SpacingVertical variant={SPACING_32} />

        <InputTitle />
        <InputLists />
      </ModalBody>
      <ModalFoot>
        <Button onClick={handleClose} kind={BUTTON_VARIANT_SECONDARY}>
          {intl.formatMessage({ id: 'Load.MailupCommon.Cancel' })}
        </Button>
        <Button
          onClick={handleConfirm}
          kind={BUTTON_VARIANT_PRIMARY}
          disabled={!validForm}
        >
          {intl.formatMessage({ id: 'Load.Bee.ModalCopy' })}
        </Button>
      </ModalFoot>
    </Modal>
  )
}

export default ModalCopy
